'use client';

import { sendEvent } from '../../gtm/event';
import { type DietCatalogDetail } from '@/features/diets/types';
import { useEffect } from 'react';

export const EventCustomizeDiet = ({
  item,
  edit,
}: {
  item: DietCatalogDetail;
  edit?: boolean;
}) => {
  useEffect(() => {
    sendEvent({
      event: edit ? 'CUSTOMIZE_DIET_EDIT' : 'CUSTOMIZE_DIET',
      ecommerce: {
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_brand: item.catering.name,
            item_category: item.tags.map((tag) => tag.name).join(', '),
          },
        ],
      },
    });
  }, []);

  return null;
};
